import { CustomStyleSheet } from '../../../utils/rn/tools';
import { gray_3 } from '../../../styles/rn';
export default CustomStyleSheet({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 12,
    backgroundColor: '#fff',
    borderRadius: 4
  },
  largeBorderRadius: {
    borderRadius: 15
  },
  baseTextStyles: {
    fontSize: 12,
    lineHeight: 14,
    color: gray_3
  },
  buttonText: {
    color: '#4080ee'
  },
  primaryColor: {
    color: '#ee4d2d'
  }
});